export default __webpack_public_path__ + "static/media/faqlaptop.ed697b64.svg";